"use client";

const Theme11SharedStyles = () => (
    <style jsx global>{`
    .keen-slider {
      display: flex;
      overflow: hidden;
      position: relative;
      touch-action: pan-y;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      width: 100%;
    }

    .keen-slider__slide {
      min-height: 100%;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .slick-slider {
      position: relative;
      display: block;
      box-sizing: border-box;
      user-select: none;
      touch-action: pan-y;
      -webkit-tap-highlight-color: transparent;
    }

    .slick-list {
      position: relative;
      display: block;
      overflow: hidden;
      margin: 0;
      padding: 0;
    }

    .slick-list:focus {
      outline: none;
    }

    .slick-list.dragging {
      cursor: pointer;
      cursor: grabbing;
    }

    .slick-track {
      position: relative;
      top: 0;
      left: 0;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    .slick-track::before,
    .slick-track::after {
      display: table;
      content: "";
    }

    .slick-track::after {
      clear: both;
    }

    .slick-slide {
      display: none;
      float: left;
      height: 100%;
      min-height: 1px;
    }

    [dir="rtl"] .slick-slide {
      float: right;
    }

    .slick-slide img {
      display: block;
    }

    .slick-slide.slick-loading img {
      display: none;
    }

    .slick-slide.dragging img {
      pointer-events: none;
    }

    .slick-initialized .slick-slide {
      display: block;
    }

    .slick-slide > div {
      height: 100%;
    }

    .slider-overlay-shared {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      background: rgba(0, 0, 0, 0.25);
      backdrop-filter: blur(8px);
      padding: 32px 24px;
      border-radius: 16px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
      width: 92%;
      max-width: 600px;
      animation: fadeInUp 0.6s ease-out;
    }

    .slider-title-shared {
      font-size: clamp(20px, 4vw, 32px);
      font-weight: 700;
      color: #fff;
      line-height: 1.3;
      margin-bottom: 16px;
    }

    .slider-btn-shared .banner-slider-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      background-color: #ff5722;
      color: #fff !important;
      font-size: 16px;
      font-weight: 600;
      text-transform: uppercase;
      border-radius: 8px;
      transition: background 0.3s ease, transform 0.2s ease;
    }

    .slider-btn-shared .banner-slider-btn:hover {
      background-color: #e64a19;
      transform: translateY(-2px);
    }

    .slider-btn-shared .banner-slider-btn i {
      transition: transform 0.3s ease;
    }

    .slider-btn-shared .banner-slider-btn:hover i {
      transform: translateX(4px);
    }

    .custom-slider-prev-shared,
    .custom-slider-next-shared {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      background: #ccccccbd;
      backdrop-filter: blur(6px);
      color: white;
      border: 1px solid rgba(255, 255, 255, 0.3);
      padding: 12px;
      border-radius: 50%;
      cursor: pointer;
      transition: background 0.3s ease-in-out, transform 0.2s ease;
      height: 48px;
      width: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .custom-slider-prev-shared:hover,
    .custom-slider-next-shared:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: translateY(-50%) scale(1.05);
    }

    .custom-slider-prev-shared button,
    .custom-slider-next-shared button {
      color: #fff;
      font-size: 18px;
      border: none;
      background: transparent;
    }

    .custom-slider-prev-shared {
      left: 16px;
    }

    .custom-slider-next-shared {
      right: 16px;
    }

    .slider-container-shared {
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    .slider-link-shared {
      display: block;
      width: 100%;
      line-height: 0;
    }

    .slider-img-shared,
    .slider-image-shared {
      width: 100%;
      height: auto;
      object-fit: contain;
      transition: opacity 0.4s ease;
      border-radius: 12px;
    }

    .slider-hydration-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      max-width: 1500px;
      margin: 0 auto;
      border-radius: 12px;
      overflow: hidden;
    }

    .fallback-shell,
    .hydrated-slider {
      position: relative;
      inset: 0;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease;
    }

    .fallback-shell {
      z-index: 1;
      pointer-events: none;
    }

    .hydrated-slider {
      z-index: 2;
      pointer-events: auto;
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translate(-50%, -40%);
      }

      to {
        opacity: 1;
        transform: translate(-50%, -50%);
      }
    }

    .super-offer-open .banner-section,
    .super-offer-open .banner-sections,
    .super-offer-open .banner-container,
    .super-offer-open .banner-slider-container,
    .super-offer-open .slider-container-wrapper,
    .super-offer-open .slider-hydration-wrapper {
      filter: blur(6px);
      transition: filter 0.2s ease;
    }

    .super-offer-overlay {
      position: fixed !important;
      inset: 0 !important;
      width: 100vw;
      height: 100vh;
      height: 100dvh;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      z-index: 99999;
      isolation: isolate;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }

    .super-offer-modal {
      position: relative;
      width: 100%;
      max-width: 900px;
      aspect-ratio: 2 / 1;
      max-height: 90vh;
      overflow: hidden;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.35);
      line-height: 0;
    }

    .super-offer-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 2;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: #fff;
      color: #333;
      font-size: 24px;
      font-weight: 700;
      line-height: 1;
      padding: 0;
      padding-bottom: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
      transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
    }

    .super-offer-close-btn:hover {
      background: #ff5722;
      color: #fff;
      transform: scale(1.12);
    }

    .super-offer-modal::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 45%;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
      opacity: 0;
      transition: opacity 0.25s ease;
    }

    .super-offer-modal:hover::after {
      opacity: 1;
    }

    @media (hover: none) {
      .super-offer-modal::after {
        opacity: 1;
      }
    }

    .super-offer-slide {
      line-height: 0;
    }

    .super-offer-slider,
    .super-offer-slider .slick-list,
    .super-offer-slider .slick-track,
    .super-offer-slider .slick-slide,
    .super-offer-slider .slick-slide > div,
    .super-offer-slide,
    .super-offer-image-link {
      height: 100%;
    }

    .super-offer-image-link {
      display: block;
      width: 100%;
      line-height: 0;
    }

    .super-offer-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .super-offer-cta-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 24px;
      z-index: 3;
      display: flex;
      justify-content: center;
      pointer-events: none;
    }

    .super-offer-cta-wrapper .super-offer-cta-btn {
      pointer-events: auto;
    }

    @media (hover: hover) {
      .super-offer-cta-wrapper {
        opacity: 0;
        transform: translateY(10px);
        transition: opacity 0.25s ease, transform 0.25s ease;
      }

      .super-offer-modal:hover .super-offer-cta-wrapper {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .super-offer-cta-btn {
      display: inline-block;
      padding: 14px 32px;
      background-color: #ff5722;
      color: #fff !important;
      font-weight: 700;
      font-size: 15px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      border-radius: 8px;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
      transition: background-color 0.2s ease, transform 0.2s ease;
    }

    .super-offer-cta-btn:hover {
      background-color: #e64a19;
      transform: translateY(-1px);
    }

    @media (max-width: 576px) {
      .super-offer-modal {
        max-width: 92vw;
        max-height: 80vh;
      }

      .super-offer-cta-wrapper {
        bottom: 16px;
      }

      .super-offer-cta-btn {
        padding: 12px 28px;
      }
    }

    .super-offer-bubble {
      position: fixed;
      left: 20px;
      bottom: 90px;
      z-index: 99999;
      width: 96px;
      height: 48px;
      border-radius: 12px;
      border: 1px solid #ff5722;
      padding: 0;
      overflow: visible;
      background: #fff !important;
      cursor: pointer;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
      transform-origin: bottom left;
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      animation: super-offer-bubble-in 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .super-offer-bubble:hover {
      transform: scale(2.2);
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
      z-index: 100000;
    }

    .super-offer-bubble::after {
      content: "";
      position: absolute;
      inset: -3px;
      border-radius: 14px;
      border: 2px solid rgba(255, 87, 34, 0.5);
      animation: super-offer-bubble-pulse 2s ease-out infinite;
      pointer-events: none;
    }

    .super-offer-bubble-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
      border-radius: 9px;
      display: block;
      overflow: hidden;
    }

    .super-offer-bubble-close {
      position: absolute;
      top: -4px;
      right: -3px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #fff !important;
      color: #333 !important;
      font-size: 16px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 2px;
      cursor: pointer;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      opacity: 0;
      transform: scale(0.7);
      transition: opacity 0.15s ease, transform 0.15s ease, background-color 0.15s ease;
      pointer-events: none;
    }

    @keyframes super-offer-bubble-in {
      from { opacity: 0; transform: translateY(10px) scale(0.95); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }

    @keyframes super-offer-bubble-pulse {
      0% { transform: scale(1); opacity: 0.65; }
      50% { transform: scale(1.1); opacity: 0.35; }
      100% { transform: scale(1); opacity: 0.65; }
    }
  `}</style>
);

export default Theme11SharedStyles;
